// @ts-check

import React, { useCallback } from "react"
import InlineMultiSelectDropdown from "../../../../../components/molecules/InlineMultiSelectDropdown.molecule"
import { useTaskReportsCommonFilters } from "../../../../../hooks/reports/useTaskReportsCommonFilters.factory"

/** @param {import("./ClientTasksReportTable.filters.types").ClientTasksReportTableFiltersParams} params */
export function useClientTasksReportTableFilters(params) {
  const { teamMembers, categories, modules, projects, loading } = params

  const teamMemberFilterTemplate = useCallback(
    /** @param {import("../../../../../components/table/types/table").FilterElementOptions} options */
    (options) => {
      /** @type {typeof InlineMultiSelectDropdown<import("../../../../../utils/report.utils").FormattedTeamMember, import("../../../../../utils/report.utils").TeamMemberGroup>} */
      const TypedDropdown = InlineMultiSelectDropdown

      return (
        <TypedDropdown
          value={options.value || []}
          options={teamMembers}
          optionGroupLabel="active"
          optionGroupChildren="items"
          optionGroupTemplate={(option) => {
            return option.active ? "Activo" : "Inactivo"
          }}
          className="tareas-por-cliente-team-member-dropdown"
          onChange={(value) =>
            options.filterCallback(value.length ? value : undefined)
          }
          loading={loading}
          hasSearchBar
          disabled={teamMembers.length === 0}
          optionLabel="label"
          optionValue="value"
          placeholder="Filtrar integrante"
          emptyFilterMessage="Sin resultados ¿Seguro que trabaja aquí?"
          hideToggleButton
          initiallyExpanded
          itemTemplate={(option) => (
            <div
              key={option.label}
              className="overflow-hidden white-space-nowrap text-overflow-ellipsis"
              title={option.label}
            >
              {option.label}
            </div>
          )}
          selectedItemsLabel={
            (options.value || []).length + " integrantes seleccionados"
          }
        />
      )
    },
    [teamMembers, loading]
  )

  const {
    categoryFilterTemplate,
    moduleFilterTemplate,
    clientFilterTemplate,
    taskNameFilterTemplate,
  } = useTaskReportsCommonFilters({ categories, modules, projects, loading })

  return {
    teamMemberFilterTemplate,
    categoryFilterTemplate,
    moduleFilterTemplate,
    clientFilterTemplate,
    taskNameFilterTemplate,
  }
}
